@use "variables" as *;

.itemDiv {
  width: 100%;
  padding: $spacing-s $spacing-m;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.itemDivWithoutTitle {
  width: 100%;
  padding: 0 $spacing-m;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.loadingDiv {
  flex-grow: 100;
  align-items: flex-start;
}

.icon {
  align-self: center;
}

.title {
  font-size: $fontSize-m;
}

.detail {
  font-size: $fontSize-s;
  white-space: pre-wrap;
  font-weight: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
